import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { ADD_DISTORTION } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const ActivateDistortion = ({
  sourceAccountId, targetAccountId, distortion, growl, fetchData,
}) => {
  const [addDistortion] = useMutation(ADD_DISTORTION);
  const intl = useIntl();
  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock-open"
        label={intl.formatMessage(messages.add)}
        disabled
        onClick={async () => {
          await addDistortion({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                distortion,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.addDistortionSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({ severity: 'error', detail: intl.formatMessage(messages.addDistortionError), sticky: true });
            });
        }}
      />
    </>
  );
};

ActivateDistortion.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  distortion: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(ActivateDistortion);
